//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressComponent from '../../common/address';
import checkBox from '../../common/checkBox.vue';
import editAddress from './editAddress.vue';
export default {
    components: {
        checkBox,
        addressComponent,
        editAddress
    },
    data() {
        return {
            addressManageShow: false,
            list: [],
            setDefault: false,
            form: {
                name: '',
                phoneNum: '',
                address: ''
            },
            addressList: [],
            addressStr: '',
            inputDisable: true //解决自动聚焦的问题
        };
    },
    //侦听属性
    watch: {
        //监听点击事件
        addressManageShow(value) {
            if (value) {
                document.body.addEventListener('click', () => {
                    this.addressManageShow = false;
                });
            } else {
                document.body.removeEventListener('click', () => {
                    this.addressManageShow = false;
                });
            }
        }
    },
    methods: {
        toAddressManage(type, item) {
            this.$refs.editAddressRef.showPopup(type, item);
        },
        showAddressSelector() {
            if (this.addressManageShow) {
                this.addressManageShow = false;
            } else {
                this.addressManageShow = true;
            }
            this.$refs.addressComponentRef.showPopup(this.addressList);
        },
        loadList() {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/receiverAddress', {
                    params: {
                        shopperId: that.$store.state.userInfo.shopperId
                    }
                })
                .then(function(res) {
                    if (res.status == 200) {
                        that.list = res.body.map(item => {
                            item.title = item.name + ' ' + item.phoneNum;
                            item.desc = item.regionDesc.replace(/\s/g, '') + item.address;
                            return item;
                        });
                        // console.log('===0' + JSON.stringify(that.list));
                    }
                });
        },
        submit() {
            let that = this;
            var one = this.form;
            if (!one.name) {
                that.$vux.toast.text('请填写收货人姓名');
                return false;
            }
            if (!one.phoneNum) {
                that.$vux.toast.text('请填写收货人手机号');
                return false;
            }
            if (!this.addressList || this.addressList.length <= 0) {
                that.$vux.toast.text('请选择省/市/区');
                return false;
            }
            if (!one.address) {
                that.$vux.toast.text('请填写街道门牌、楼层房间号等信息');
                return false;
            }
            var receiverAddress = {
                defaultAddress: that.setDefault ? 1 : 0,
                name: one.name,
                phoneNum: one.phoneNum.replace(/\s/g, ''),
                address: one.address,
                addressLabel: ''
            };
            if (this.addressList) {
                receiverAddress.province = this.addressList[0] ? this.addressList[0].regionId : '';
                receiverAddress.city = this.addressList[1] ? this.addressList[1].regionId : '';
                receiverAddress.prefecture = this.addressList[2] ? this.addressList[2].regionId : '';
                receiverAddress.town = this.addressList[3] ? this.addressList[3].regionId : '';
                receiverAddress.regionDesc = this.addressList
                    .map(item => {
                        return item.regionName;
                    })
                    .join(' ');
            }
            //编辑操作
            if (this.type == 2) {
                receiverAddress.receiverAddressId = one.receiverAddressId;
                receiverAddress.accountId = one.accountId;
            }
            var data = {
                receiverAddress: JSON.stringify(receiverAddress),
                shopperId: this.$store.state.userInfo.shopperId
            };
            this.ajaxSubmit(data);
        },
        ajaxSubmit(data) {
            let that = this;
            that.$axios.post('/api/v1.0/lonbonShop/saveReceiverAddress', that.qs.stringify(data)).then(function(response) {
                if (response.status == 200) {
                    that.$vux.toast.text('保存成功');
                    that.loadList();
                    that.resetData();
                }
            });
        },
        resetData() {
            this.addressManageShow = false;
            this.setDefault = false;
            this.form = {
                name: '',
                phoneNum: '',
                address: ''
            };
            this.addressList = [];
            this.addressStr = '';
        },
        deleteAddr(item) {
            let that = this;
            that.$vux.confirm.show({
                content: `确定要删除该地址吗？`,
                cancelText: '取消',
                confirmText: '删除',
                title: '提示',
                onConfirm() {
                    var data = {
                        receiverAddressId: item.receiverAddressId
                    };
                    that.$axios.post('/api/v1.0/lonbonShop/deleteReceiverAddress', that.qs.stringify(data)).then(function(response) {
                        if (response.status == 200) {
                            that.$vux.toast.text('删除成功');
                            that.loadList();
                        }
                    });
                }
            });
        },
        setDefaultAddr(item) {
            var form = JSON.parse(JSON.stringify(item));
            form.defaultAddress = 1;
            var data = {
                receiverAddress: JSON.stringify(form),
                shopperId: this.$store.state.userInfo.shopperId
            };
            let that = this;
            that.$axios.post('/api/v1.0/lonbonShop/saveReceiverAddress', that.qs.stringify(data)).then(function(response) {
                if (response.status == 200) {
                    that.$vux.toast.text('设置成功');
                    that.loadList();
                }
            });
        },
        selectAddressHandle(list) {
            this.addressList = list;
            var arr = this.addressList.map(item => {
                return item.regionName;
            });
            this.addressStr = arr.join('/');
            this.addressManageShow = false;
        }
    },
    mounted() {
        this.loadList();
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/personalSettings/shippingAddress.vue